module.exports = __webpack_public_path__ + "img/nv.df773203.png";